
<nav-bar></nav-bar>
<div class="page-news scroller column center-v">
  <w-page-section *ngFor="let el of news" title="{{ get_news_for_lang(el.title)}}" [collapsed]="false">
    <div class="right">{{ el.news_date}}</div>
    <f-facet class="fullwidth" name="content">
      <ul class="flex flexWrap fullwidth">
        <li class="fullwidth">
          <h4 [innerHTML]="get_news_for_lang(el.payload)"></h4>
        </li>
      </ul>
    </f-facet>
  </w-page-section>
</div>
